import React, { useEffect, useState } from "react";
import { Modal, Input, Button, Form, Typography, message } from "antd";
import { InputOtp } from "primereact/inputotp";
import {
  getOtpForForgotPassword,
  getOtpForForgotPasswordResend,
  verifyOtpForForgotPassword,
} from "../services/Un_auth_services";
import { useNavigate, useSearchParams } from "react-router";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const { Title, Text } = Typography;

interface ResetPasswordModalProps {
  username: string;
  email: string;
  refId: string;
  visible: boolean;
  onClose: () => void;
}

const ResetPasswordModal: React.FC<ResetPasswordModalProps> = ({
  username,
  email,
  refId,
  visible,
  onClose,
}) => {
  const [form] = Form.useForm();
  const language = useSelector((state: any) => state.auth.language);
  const [isSuccess, setIsSuccess] = useState(false);
  const [otp, setOtp] = useState<string | number>("");
  const [loading, setLoading] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [refrId, setRefrId] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [countdown, setCountdown] = useState(600);
  const [resendAttempts, setResendAttempts] = useState(0);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  const [searchParams] = useSearchParams();
  const role = searchParams.get("role");

  const navigate = useNavigate();

  const passwordSchema = Yup.object().shape({
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Password must contain at least one special character"
      )
      .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "Password must contain at least one lowercase letter")
      .required("Please enter your new password"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password")], "Passwords must match")
      .required("Please confirm your password"),
  });

  useEffect(() => {
  const expiry = localStorage.getItem("exp");

  if (expiry) {
    const remaining = Math.max(0, Math.floor((+expiry - Date.now()) / 1000));
    setCountdown(remaining);
  } else {
    setCountdown(180);
  }
}, [visible]);

  // useEffect(() => {
  //   if (countdown > 0) {
  //     const timer = setInterval(() => {
  //       setCountdown((prev) => {
  //         if (prev > 0) {
  //           return prev - 1; 
  //         }
  //         clearInterval(timer); 
  //         return 0;
  //       });
  //     }, 1000);
  
  //     return () => clearInterval(timer);
  //   } else {
  //     setIsResendDisabled(resendAttempts >= 4);
  //   }
  // }, [countdown, resendAttempts]);
  
  useEffect(() => {
  if (countdown > 0) {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev > 1) {
          return prev - 1;
        } else {
          clearInterval(timer);
          localStorage.removeItem("otp_timer_expires");
          localStorage.removeItem("otp_ref_id");
          return 0;
        }
      });
    }, 1000);

    return () => clearInterval(timer);
  } else {
    // Countdown ended
    setIsResendDisabled(resendAttempts >= 4 ? true : false);
  }
}, [countdown, resendAttempts]);


  const handleSubmit = async (values: {
    password: string;
    confirmPassword: string;
  }) => {
    try {
      await passwordSchema.validate(values, { abortEarly: false });

      setLoading(true);

      const requestData =
        role === "Trader_Login" || role === "Panel_Engineer_Login"
          ? {
              email: email,
              mobileNo: "",
              Password: values.password,
              enteredOTP: otp,
              RefId: refrId || refId,
              role,
            }
          : {
              email: email,
              username: username,
              mobile: "",
              key: "Dist",
              Password: values.password,
              enteredOTP: otp,
              RefId: refrId || refId,
              role,
            };

      const otpResponse = await verifyOtpForForgotPassword(requestData);

      if (otpResponse.success) {
        alert(otpResponse.message);
        setIsSuccess(true);
         localStorage.removeItem("exp");
      } else if (otpResponse.success == false) {
        alert(otpResponse.message);
        message.error(otpResponse.message);
      }
    } catch (error: unknown) {
      const err = error as any;

      if (err.response) {
        const apiErrorMessage =
          err.response?.data?.message || "❌ Unknown API error occurred.";
        alert(apiErrorMessage);
        message.error(apiErrorMessage);
      } else if (error instanceof Yup.ValidationError) {
        const validationErrors = error.inner
          .map((err) => err.message)
          .join("\n");

        form.setFields(
          error.inner.map((err) => ({ name: err.path, errors: [err.message] }))
        );

        alert(validationErrors);
      } else {
        alert("❌ An unexpected error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };
  const handleResendOtp = async (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    if (isResendDisabled || resendAttempts >= 4) return;
    if (isSubmitting) return;

    setIsSubmitting(true);
    setCountdown(180); // Reset timer
    setIsResendDisabled(true);
    setResendAttempts((prev) => prev + 1);

    let values;

    if (role === "Trader_Login" || role === "Panel_Engineer_Login") {
      values = { email: email, mobileNo: "", role, RefId: refrId || refId, };
    } else {
      values = {
        email: email,
        username: username,
        mobile: "",
        key: "Dist",
        role,
        RefId: refrId || refId,
      };
    }

    try {
      const response = await getOtpForForgotPasswordResend(values);
      if (response.Status) {
        alert(response.Message);
        setRefrId(response.RefId);
          const expiry = Date.now() + 10 * 60 * 1000;

      localStorage.setItem("exp", expiry.toString());
      } else {
        alert(response.Message);
      }
    } catch (error) {
      // //.error("Error fetching OTP:", error);
    } finally {
      setTimeout(() => setIsSubmitting(false), 30000);
    }
  };

  return (
    <Modal
      title="Reset Password"
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
    >
      {isSuccess ? (
        <div className="text-center">
          <Title level={3} className="mb-2 text-success">
            {language.succ}
          </Title>
          <Text>{language.p_reset}</Text>
          <Button
            type="primary"
            className="w-100 mt-3"
            onClick={() => navigate(`/login?role=${role}`)}
          >
            {language.bts}
          </Button>
        </div>
      ) : (
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item label="New Password" name="password">
            <Input.Password maxLength={20} />
          </Form.Item>
          <Form.Item label="Confirm Password" name="confirmPassword">
            <Input.Password maxLength={20} />
          </Form.Item>
          <div className="text-center mb-3">
            <Title level={4} className="text-success">
              {language.en_otp}
            </Title>
          </div>
          <div className="text-center otp-input p-3 border rounded shadow-sm">
            <div className="d-flex align-items-center mb-3 p-3">
              <InputOtp
                value={otp}
                onChange={(e) => setOtp(e.value ?? "")}
                integerOnly
              />
            </div>
            <div className="badge bg-success-transparent mb-3">
              <p className="d-flex align-items-center">
                <i className="ti ti-clock me-1" />
                {Math.floor(countdown / 60)}:
                {(countdown % 60).toString().padStart(2, "0")}
              </p>
            </div>
          </div>
          <div className="mb-3 d-flex justify-content-center">
            <p className="text-gray-9">
              {language.dgto}?{" "}
              <Link
                to="#"
                className={`text-success ${isResendDisabled ? "disabled" : ""}`}
                onClick={handleResendOtp}
                style={{ pointerEvents: isResendDisabled ? "none" : "auto" }}
              >
                {resendAttempts >= 3
                  ? "Resend limit reached"
                  : countdown > 0
                  ? `Resend `
                  : language.resend}
              </Link>
            </p>
          </div>
          <Form.Item className="mt-3">
            <button
              type="submit"
              className="btn btn-success w-100"
              disabled={loading}
            >
              {loading ? language.verifying : language.res_pass}
            </button>
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default ResetPasswordModal;
